import React from 'react'
import { Button } from '@mui/material'
import { FormikProps } from 'formik'
import { getDevEmail } from 'src/legacy/components/addParticipantForms/getDevEmail'
import useLoadSources from 'src/participantsView/useLoadSources'
import { PROGRAM_IDS, REGIONS } from 'src/config'

type ParticipantFormData = {
  firstname: string
  lastname: string
  email: string
  source: string | undefined
  referralName: string
  region: string
  programID: string
  memberID: string | undefined
}

type Props = {
  form: FormikProps<ParticipantFormData>
  onAutofill?: () => void
}

// For development purposes only
export function AutoFillParticipantFormButton({ form, onAutofill }: Props) {
  const sources = useLoadSources()

  const autoFillFormData = () => {
    const { firstName, lastName, email } = getDevEmail()

    form.setFieldValue('firstname', firstName)
    form.setFieldValue('lastname', lastName)
    form.setFieldValue('email', email)
    form.setFieldValue('referralName', 'Test HCP')
    form.setFieldValue('memberID', '12345678')

    if (sources && sources.length > 0) {
      const cignaSource = sources.find((source) => source === 'Cigna')
      form.setFieldValue('source', cignaSource ?? sources[0])
    }

    if (PROGRAM_IDS && PROGRAM_IDS.length > 0) {
      const masterProgramID = PROGRAM_IDS.find((programID) => programID === 'master_v5')
      form.setFieldValue('programID', masterProgramID ?? PROGRAM_IDS[0])
    }

    if (REGIONS && REGIONS.length > 0) {
      const californiaRegion = REGIONS.find((region) => region === 'CA')
      form.setFieldValue('region', californiaRegion ?? REGIONS[0])
    }

    onAutofill?.()
  }

  return (
    <Button type="button" variant="outlined" onClick={autoFillFormData} size="small">
      AUTOFILL
    </Button>
  )
}
